import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui';
import { Target, Users, HeartPulse, Unlock, Megaphone, Scale, Award, Network } from 'lucide-react';
const benefits = [{
  icon: Target,
  title: 'Claritate în obiective',
  desc: 'Știi ce vrei, de ce vrei și cum ajungi acolo, fără să mai rătăcești între intenții și amânări.'
}, {
  icon: Users,
  title: 'Comunicare mai bună cu oamenii din viața ta',
  desc: 'Înveți cum gândesc ceilalți și cum să le vorbești pe limba lor, nu pe a ta.'
}, {
  icon: HeartPulse,
  title: 'Gestionarea emoțiilor în timp real',
  desc: 'Nu mai ești luat prin surprindere de reacțiile tale. Înveți să intri intenționat în starea potrivită.'
}, {
  icon: Unlock,
  title: 'Depășirea blocajelor și tiparelor vechi',
  desc: 'Identifici exact ce te ține pe loc și ai tehnici concrete să schimbi asta, nu doar să înțelegi că există.'
}, {
  icon: Megaphone,
  title: 'Influență naturală și convingătoare',
  desc: 'Comunici mai clar, mai strategic și mai uman, în relații, în business, în leadership.'
}, {
  icon: Scale,
  title: 'Echilibru între trecut și viitor',
  desc: 'Eliberezi ce te trage înapoi și construiești o direcție interioară mai solidă.'
}, {
  icon: Award,
  title: 'Certificare NLP națională și internațională',
  desc: 'Diplomă recunoscută care îți validează competențele și deschide noi oportunități.'
}, {
  icon: Network,
  title: 'O comunitate de oameni care cresc împreună',
  desc: 'Colegii cu care parcurgi acest drum devin resurse reale, nu doar cunoștințe de curs.'
}];
export const Benefits = () => {
  return <section className="py-24 bg-[#F5FAFC] relative overflow-hidden" data-id="element-18">
      <div className="container mx-auto px-6" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-20" data-id="element-20">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-navy mb-6" data-id="element-21">
            Ce obții concret după cele 7 luni de NLP Practitioner
          </h2>
          <div className="w-24 h-px bg-gold mx-auto" data-id="element-22" />
        </motion.div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto" data-id="element-23">
          {benefits.map((benefit, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white border border-navy/10 p-8 group hover:border-gold/40 hover:shadow-lg transition-all duration-300 relative overflow-hidden" data-id="element-24">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-gold/60 via-gold/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-25" />
              <div className="w-14 h-14 rounded-full border-2 border-gold/30 flex items-center justify-center bg-gold/5 group-hover:border-gold/60 group-hover:bg-gold/10 transition-all duration-300 mb-6" data-id="element-26">
                <benefit.icon className="w-6 h-6 text-navy stroke-[1.5]" data-id="element-27" />
              </div>
              <h3 className="font-serif text-xl font-bold text-navy mb-3 leading-tight" data-id="element-28">
                {benefit.title}
              </h3>
              <p className="font-sans text-navy/70 leading-relaxed text-xl" data-id="element-29">
                {benefit.desc}
              </p>
            </motion.div>)}
        </div>
        <div className="text-center mt-16" data-id="element-30">
          <Button data-id="element-31">Scrie-mi pe WhatsApp pentru detalii!</Button>
        </div>
      </div>
    </section>;
};